module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-07@2x.9a718c96.jpg";